import React, { Component } from 'react';
import SelectWrapper from '../blueprintWrappers/SelectWrapper';
import SubmitButton from '../blueprintWrappers/SubmitButton';
import CancelButton from '../blueprintWrappers/CancelButton';
import moment from 'moment-timezone';

class NotesElement extends Component {
	render() { 
		const { noteType, note } = this.props;
		return <div className = "notes_element">
			{this.display()}
		</div>
	}
	
	display = () => {
		const { isEditing } = this.props;
		return isEditing ? this.modeEditing() : this.modeDisplay();
	}
	
	modeEditing = () => {
		const { currentText, currentNoteType, noteTextChange, noteTypeChange, editOff, saveNote } = this.props;
		return <div className = "note_row"> 
			<span>Note: </span>
			<div className="pt-fill">
				<textarea
					value = { currentText }
					onChange = { noteTextChange }
					className = 'pt-fill pt-input'
				/>
			</div>
			<br />
			<span>Note Type: </span>
			<SelectWrapper 
				value = { currentNoteType }
				onChange = { noteTypeChange }
				returnObj = { {} }
			>
				{this.noteTypeOptions()}
			</SelectWrapper>
			<br />
			<div className="pt-button-group note_row_options pt-fill">
				<SubmitButton
					display = 'Save Note'
					onClick = {saveNote}
				/>
				<CancelButton
					onClick = { editOff }
				/>
			</div>
		</div>;
	}
	
	modeDisplay = () => {
		const { note, noteType, editOn, removeNote } = this.props;
		return <div className = {this.noteRowClass()}>
			<span className = 'pt-icon-annotation note_icon'/>
			<span className = 'note_prepend'>Type: {this.noteTypes()[noteType]}</span>
			<button 
				title = 'Edit'
				className = 'pt-button pt-small pt-minimal pt-icon-edit note_edit_button'
				onClick = { editOn }
			/>
			<br />
			<span className="note_text">{note}</span>
			<button 
				title = 'Remove'
				className = 'pt-button pt-small pt-minimal note_edit_button pt-icon-trash'
				onClick = { removeNote }
			/>
			<br />
			<div className="notes_subtitle">
				{this.sectionUser()}
				{this.sectionTime()}
			</div>
		</div>
	}
	
	noteRowClass = () => {
		const { noteType } = this.props;
		switch (noteType) {
			case 'issue':
				return 'note_row issue';
			case 'communication':
				return 'note_row communication'
			default:
				return 'note_row';
		}
	}
	
	sectionTime = () => {
		const { updateDate, updateTime } = this.props;
		if(updateDate === null) {
			return null;
		}
		const timeDisplay =  updateTime + 'H-' + moment(updateDate).format('MM/DD/YYYY'); 
		return <span className="submmited_on">on: { timeDisplay }</span>
	}
	
	sectionUser = () => {
		const { updatedBy } = this.props;
		return <span className="submitted_by">Last updated by <span className="submmited_on_inner">{updatedBy}</span> </span>
	}
	
	noteTypeOptions = () => {
		const noteTypes = this.noteTypes();
		return Object.keys(noteTypes).map((noteType, i) => {
			return <option 
				value = { noteType }
				key = {i}
			>
				{noteTypes[noteType]}
			</option>
		})
	}
	
	noteTypes = () => {
		const types = {
			'issue': 'Issue',
			'communication': 'Communication'
		}
		return types;
	}
}

export default NotesElement;



// WEBPACK FOOTER //
// ./src/components/notes/NotesElement.jsx